import modalGallery from "./modal-gallery";
import viewport from "./viewport";


export default function () {

    $('body').on('click', '.js-modal-link', function (e) {

        let url = $(this).attr('href');

        let type = $(this).attr('data-type') || 'inline';

        $.fancybox.open({
            src  : url,
            type: type,
            opts : window.fancyOpt
        });

        e.preventDefault();

    });

    //$('.js-modal-link').fancybox(window.fancyOpt);

    $('body').off('click', '.js-open-gallery');

    $('body').on('click', '.js-open-gallery', function (e) {
        e.preventDefault();

        if(viewport().width > 980) {
            let ajaxSrc = $(this).attr('data-href');

            let index = $(this).attr('data-swiper-slide-index');

            $.fancybox.open(
                {
                    closeExisting: false,
                    autoFocus: false,
                    backFocus: false,
                    slideShow: false,
                    fullScreen: false,
                    src: ajaxSrc,
                    thumbs: false,
                    touch: false,
                    type: 'ajax',
                    closeClickOutside: true,
                    animationDuration: 600,
                    hash: false,
                    btnTpl: {
                        smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg width="20" height="20"><use xlink:href="#close"></use></svg></button>'
                    },
                    afterLoad: function () {
                        modalGallery(index);
                    }
                }
            );
        }

    });

    $('body').off('click', '.header-cart__link');

    $('body').on('click', '.header-cart__link', function (e) {
        e.preventDefault();

        if(viewport().width < 765 && $('.header-cart-drop').length >0) {
            $.fancybox.open(
                $('.header-cart-drop'),
                {
                    closeExisting: false,
                    autoFocus: false,
                    backFocus: false,
                    slideShow: false,
                    fullScreen: false,
                    thumbs: false,
                    touch: false,
                    closeClickOutside: true,
                    animationDuration: 600,
                    hash: false,
                    btnTpl: {
                        smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg width="20" height="20"><use xlink:href="#close"></use></svg></button>'
                    }
                }
            );
        }

    });

    $('.js-modal-gallery').fancybox(window.fancyOpt3);

}
